<template lang="pug">
  v-row
    v-col(cols="12")
      h1 Группы
    v-col(cols="12")
      v-slide-y-reverse-transition(mode="out-in")
        v-expansion-panels(
          v-if="!$loader.isLoading"
          v-model="expansionPanels"
          accordion
        )
          v-expansion-panel(
            v-for="(course, i) in courses"
            :key="course.id"
          )
            v-expansion-panel-header.py-2(
              expand-icon=""
              disable-icon-rotate
            )
              .d-flex.align-center
                .mr-4
                  v-icon {{ getIcon(i) }}
                .course-title
                  span Группы курса "{{ course.title }}"
                v-spacer
                v-btn(
                  v-if="isOrganization"
                  :to="{ name: 'GroupCreate', params: { courseId: course.id }}"
                  color="success"
                  title="Создать группу для данного курса"
                  small rounded
                )
                  v-icon mdi-plus
                  span.ml-2.d-none.d-sm-block Добавить группу
            v-expansion-panel-content
              v-fade-transition(hide-on-leave)
                v-row(v-if="groupsLoading[course.id]" key="loader")
                  v-col(v-for="loader in 2" :key="loader" cols="6" xl="4")
                    v-skeleton-loader(type="card, article, actions")
                v-row(v-if="course.groups" key="content")
                  v-col(v-for="group in course.groups" :key="group.id" cols="6" xl="4")
                    group-card(:group="group" @delete="deleteGroup(course.id, group.id)")
                  v-col(v-if="!course.groups.length")
                    span.ml-2.grey--text У данного курса нет групп
                      v-btn.ml-3(
                        :to="{ name: 'GroupCreate', params: { courseId: course.id }}"
                        color="primary"
                        title="Создать группу для данного курса"
                        small rounded depressed
                      )
                        v-icon(left small) mdi-plus
                        | Создать
    delete-dialog(
      v-model="showDeleteDialog"
      :request="$api.groups.deleteGroup"
      :request-id="deleteId.groupId"
      @delete="onDelete"
    )

</template>

<script>
import { mapGetters } from 'vuex';
import GroupCard from '@/modules/Groups/components/GroupCard.vue';

export default {
  name: 'GroupList',
  components: { GroupCard },
  data() {
    return {
      courses: [],
      activeCourseId: null,
      loading: true,
      groupsLoading: {},
      expansionPanels: null,
      deleteId: {},
      showDeleteDialog: false,
    };
  },
  computed: {
    ...mapGetters({
      userData: 'auth/userData',
      isTeacher: 'auth/isTeacher',
      isOrganization: 'auth/isOrganization',
      isStudent: 'auth/isStudent',
    }),
  },
  watch: {
    expansionPanels(val) {
      if (typeof val !== 'number') return;
      const courseId = this.courses[val].id;
      this.getCourseGroups(courseId);
    },
  },
  mounted() {
    this.getCourseList();
  },
  methods: {
    async getCourseList() {
      this.$loader.start();
      const params = {};
      if (this.isStudent || this.isTeacher || this.$user.isListener) params['search[trained]'] = this.userData.id;
      if (this.isOrganization) params['search[course_authors]'] = this.userData.id;

      await this.$rHandler(
        this.$api.courses.getCourseList(params),
        (r) => {
          this.courses = r.data.data;
          if (this.isStudent) {
            this.courses.forEach((c) => {
              this.$set(c, 'groups', c.user_training_groups);
            });
          }
        },
      );
      this.$loader.stop();
    },
    getCourseGroups(courseId) {
      const course = this.courses.find((c) => c.id === courseId);
      if (course.groups) return;

      this.$set(this.groupsLoading, courseId, true);
      const params = {
        'search[course_id]': courseId,
        'search[my_self]': 1,
      };
      this.$rHandler(
        this.$api.groups.getGroupList(params),
        (r) => {
          this.$set(course, 'groups', r.data.data);
          this.$delete(this.groupsLoading, courseId);
        },
      );
    },
    deleteGroup(courseId, groupId) {
      this.deleteId.groupId = groupId;
      this.deleteId.courseId = courseId;
      this.showDeleteDialog = true;
    },
    onDelete() {
      try {
        const course = this.courses.find((c) => c.id === this.deleteId.courseId);
        course.groups = course.groups.filter((g) => g.id !== this.deleteId.groupId);
      } catch (e) {
        console.error('Ошибки при удалении группы из интерфейса', e);
      }
    },
    getIcon(id) {
      return this.expansionPanels === id ? 'mdi-minus' : 'mdi-plus';
    },
  },
};
</script>

<style lang="scss" scoped>
.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 0;
}

.course-title {
  font-size: 1rem;
}

.v-expansion-panel {
  &:before {
    //box-shadow: 0 2px 14px -10px #000;
    box-shadow: none;
  }
}

.v-list-item__title, .v-list-item__subtitle {
  flex: 1 1 auto;
}

</style>
